import axiosClient from "../../services/shared/api/axios-client";
import { VerifyExerciseRequest, VerifyExerciseResponse, EvaluateExerciseResponse, ExerciseItem } from "./exercise.interfaces";

/**
 * Busca exercícios para um módulo específico através da API
 * GET /api/students/modules/{moduleId}/exercises
 * @param moduleId ID do módulo
 * @returns Lista de exercícios (ModuleExerciseDto do backend)
 */
export const apiFetchExercisesByModule = async (moduleId: string): Promise<Exercise[]> => {
  try {
    const response = await axiosClient.get<Exercise[]>(`/students/modules/${moduleId}/exercises`);
    return response.data;
  } catch (error) {
    console.error("Error fetching exercises from API:", error);
    throw error;
  }
};

/**
 * Avalia a resposta de um exercício através da API
 * @param data Dados do exercício e resposta do aluno
 * @returns Objeto com o resultado da avaliação
 */
/**
 * Avalia a resposta de um exercício através da API
 * POST /api/students/exercises/evaluate
 * @param data Dados do exercício e resposta do aluno
 * @returns Objeto com o resultado da avaliação (pode incluir dados de progresso)
 */
export const apiEvaluateExerciseAnswer = async (data: VerifyExerciseRequest): Promise<EvaluateExerciseResponse> => {
  try {
    const response = await axiosClient.post<EvaluateExerciseResponse>(`/students/exercises/evaluate`, data);
    return response.data;
  } catch (error) {
    console.error("Error evaluating exercise from API:", error);
    throw error;
  }
};

/**
 * Avalia a resposta sem registrar progresso nem verificar duplicatas.
 * POST /api/students/exercises/evaluate-only
 * Usado pelo teste de módulo para feedback em tempo real por questão.
 */
export const apiEvaluateExerciseAnswerOnly = async (data: VerifyExerciseRequest): Promise<EvaluateExerciseResponse> => {
  const response = await axiosClient.post<EvaluateExerciseResponse>(`/students/exercises/evaluate-only`, data);
  return response.data;
};
